<template>
  <div />
</template>

<script>
import { mode } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');

export default {
  name: 'ProceedAbandonedCase',
  inject: ['$validator'],
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
  },
  mounted() {
  },
  methods: {},
};
</script>